var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section-results"},[_c('p',{staticStyle:{"font-size":"12px","color":"black"}},[_vm._v("\n      Section"+_vm._s(" ")),_c('span',{style:(_vm.window.width < 480
            ? 'font-size:12px;color:rgb(133, 183, 248)'
            : 'font-size:16px;color:rgb(133, 183, 248)')},[_vm._v(_vm._s(_vm.entitled))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a9b6536","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resultats/section/SectionTitle.vue
// module id = null
// module chunks = 